import './index.css';

export default {
  name: 'AnumberRange',
  props: {
    value: { type: null, default: () => undefined },
    controls: { type: Boolean, default: () => false },
    placeholders: { type: Array, default: () => ['最大值', '最小值'] },
    max: { type: String | Number, default: () => 10000000000 },
    min: { type: String | Number, default: () => -10000000000 },
  },
  data() {
    return ({
      values: undefined,
      maxValue: undefined,
      minValue: undefined,
    });
  },
  watch: {
    value() {
      this.create();
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.values = this.value;
      if (this.value) {
        if (Array.isArray(this.value)) {
          this.maxValue = this.value[0];
          this.minValue = this.value[1];
        } else if ((typeof this.value === 'string') && (this.value.indexOf(',') !== -1)) {
          const value = this.values.split(',');
          this.maxValue = value[0];
          this.minValue = value[1];
        }
      } else {
        this.maxValue = undefined;
        this.minValue = undefined;
      }
    },
    input() {
      this.correction();
      this.$emit('input', this.values);
    },
    change() {
      this.correction();
      this.$emit('change', this.values);
    },
    correction() {
      if (this.minValue > this.maxValue) {
        this.minValue = (this.maxValue - 1);
      }
      if (this.maxValue < this.minValue) {
        this.maxValue = (this.minValue + 1);
      }
      if ((this.minValue !== undefined) && (this.maxValue !== undefined)) {
        this.values = [this.maxValue, this.minValue];
      }
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div class="a-number-range">
        <el-row gutter={14}>
          <el-col span={12}>
            <el-input-number
              v-model={this.maxValue}
              min={Number(this.min)}
              max={Number(this.max)}
              on-input={this.input}
              on-change={this.change}
              placeholder={this.placeholders[0]}
              controls={this.controls}
              attrs={attrs}
            />
          </el-col>
          <el-col span={12}>
            <el-input-number
              v-model={this.minValue}
              min={Number(this.min)}
              max={Number(this.max)}
              on-input={this.input}
              on-change={this.change}
              placeholder={this.placeholders[1]}
              controls={this.controls}
              attrs={attrs}
            />
          </el-col>
        </el-row>
      </div>
    );
  },
}